<template>
  <div class="max-tabs">
    <div class="max-tabs__list" role="tablist" :aria-label="node.label || undefined" @keydown="onKeydown">
      <button
        v-for="(tab, i) in tabs"
        :id="baseId + '-tab-' + i"
        :key="i"
        ref="buttons"
        type="button"
        role="tab"
        class="max-tabs__tab"
        :aria-selected="i === active"
        :aria-controls="baseId + '-panel-' + i"
        :tabindex="i === active ? 0 : -1"
        @click="active = i"
      >
        {{ tab.title || i + 1 }}
      </button>
    </div>
    <div
      v-if="tabs[active]"
      :id="baseId + '-panel-' + active"
      class="max-tabs__panel"
      role="tabpanel"
      :aria-labelledby="baseId + '-tab-' + active"
      tabindex="0"
    >
      <MaxNode :key="active" :node="tabs[active]" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, useId, watch } from 'vue'
import { MAX_TABS } from '../core/document.ts'

const props = defineProps<{ node: any }>()

const baseId = 'max-tabs-' + useId()
const active = ref(0)
const buttons = ref<HTMLButtonElement[]>([])
const tabs = computed(() => (Array.isArray(props.node.children) ? props.node.children : []).slice(0, MAX_TABS))

watch(() => tabs.value.length, (n) => {
  if (active.value >= n) active.value = 0
})

function onKeydown (event: KeyboardEvent) {
  const n = tabs.value.length
  if (!n) return
  let next: number | null = null
  if (event.key === 'ArrowRight') next = (active.value + 1) % n
  else if (event.key === 'ArrowLeft') next = (active.value - 1 + n) % n
  else if (event.key === 'Home') next = 0
  else if (event.key === 'End') next = n - 1
  if (next === null) return
  event.preventDefault()
  active.value = next
  buttons.value[next]?.focus()
}
</script>
